import React from "react";
import { useController } from "react-hook-form";

import { StyledRadio } from "./booleanRadio.style";

const BooleanRadio = ({
  control,
  value,
  name,
  required,
  readOnly,
  label,
  disabled,
  shouldUnregister = false,
  ...rest
}) => {
  const { field } = useController({
    name,
    control,
    rules: {
      required: {
        value: required,
        message: "This field is required",
      },
      value,
    },
    disabled: disabled,
    shouldUnregister: shouldUnregister,
  });

  return (
    <StyledRadio>
      <input
        type="radio"
        {...field}
        onChange={() =>
          field.onChange(
            value === "true" ? true || value === "false" : false || value,
          )
        }
        disabled={readOnly || disabled}
        checked={field.value === value}
        {...rest}
      />
      <span className="text">{label || value}</span>
      <span className="checkmark"></span>
    </StyledRadio>
  );
};

export default BooleanRadio;
